export default __webpack_public_path__ + "static/media/badge-icon-black.de994fef.svg";